import React, { useState, useEffect } from 'react';
import Button from '../CommonButton';

import styles from './accordion.css';

const AccordionItem = ({ title, content, activeAccordion, index, handleAccordionTrigger }) => {
    // Current Accordion ID
    // eslint-disable-next-line no-unused-vars
    const [currentAccordion, setCurrentAccordion] = useState(`${index}-accordion`);
    // State to open/close accordion
    const [isAccordionOpen, setAccordionOpen] = useState(false);

    useEffect(() => {
        // Close any other opened accordions
        if (activeAccordion !== currentAccordion) {
            setAccordionOpen(false);
        }
    }, [activeAccordion]);

    const handleTrigger = () => {
        // Set to open/close current accordion
        setAccordionOpen(!isAccordionOpen);
        // set current accordionID as active one
        handleAccordionTrigger(`${index}-accordion`);
    };

    return (
        <div className={styles.wrapper}>
            <Button
                modifier={`${styles.trigger} ${isAccordionOpen ? styles['trigger--active'] : ''}`}
                onClick={handleTrigger}
                {...{ 'aria-controls': `${index}-content`, 'aria-expanded': !!isAccordionOpen }}
            >{title}</Button>
            {isAccordionOpen &&
                <div
                    className={styles.content}
                    id={`${index}-content`}
                >
                    {content}
                </div>
            }
        </div>
    );
};

export default AccordionItem;
